import { Injectable } from '@angular/core';
import { SipService } from '@components/chat/chat-dialer/sip.service';
import { UserHelperService } from '@helpers/user-helper.service';
import { BehaviorSubject, debounceTime, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SipConnectionManagerService {
  constructor(private sipService: SipService, private userHelperService: UserHelperService) {}

  private subscriptions: Subscription[] = [];
  private eventSubject = new BehaviorSubject<{ enabled: boolean; socketId: string; first?: boolean } | null>(null);
  private alertSubject = new BehaviorSubject<{ message: string; title: string; warning: boolean } | null>(null);
  public alert$ = this.alertSubject.asObservable();

  async onSipEnabledEvent(data) {
    this.eventSubject.next(data);
  }

  public async listenEvents() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    const userData = await this.userHelperService.getSocketLoginData();
    if (userData?.ramal) {
      this.subscriptions.push(
        this.eventSubject
          .asObservable()
          .pipe(debounceTime(800))
          .subscribe(async (data) => {
            if (data && data.enabled) {
              await this.sipService.init();
              if (!data.first) {
                this.alertSubject.next({
                  message: 'PABX_ENABLED_ALERT',
                  title: 'PABX_ENABLED_TITLE',
                  warning: false,
                });
              }
            }
          })
      );
    }
  }
}
